/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2022, Bulb Inc. For more information, please email contact@hellobulb.com.
*/
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SaveStateStore } from './save-state.store';
import { SerialSaveService } from './serial-save.service';

/**
 * Module for save specific services and components.
 */
@NgModule({
  providers: [
    SaveStateStore,
    SerialSaveService,
  ],
  declarations: [],
  imports: [
    CommonModule,
  ],
})
export class SaveModule { }
